var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgRecreationParks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.363 0.680615C31.1748 -0.222705 32.5762 -0.227588 33.3938 0.670361L51.4512 20.5039C52.6663 21.8383 51.7322 24 49.9402 24H43.7087L51.4512 32.5039C52.6663 33.8383 51.7322 36 49.9402 36H43.7087L51.4512 44.5039C52.6663 45.8383 51.7322 48 49.9402 48H36V56H64V64H36H28H0V56H28V48H14.0598C12.2742 48 11.3376 45.8515 12.5398 44.5141L20.1909 36H14.0598C12.2742 36 11.3376 33.8515 12.5398 32.5141L20.1909 24H14.0598C12.2742 24 11.3376 21.8515 12.5398 20.5141L30.363 0.680615Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecreationParks);
export default __webpack_public_path__ + "static/media/recreation-parks.d98b54cc.svg";
export { ForwardRef as ReactComponent };